import { render, staticRenderFns } from "./layoutTab.vue?vue&type=template&id=58b26cd2&scoped=true&"
import script from "./layoutTab.vue?vue&type=script&lang=js&"
export * from "./layoutTab.vue?vue&type=script&lang=js&"
import style0 from "./layoutTab.vue?vue&type=style&index=0&id=58b26cd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b26cd2",
  null
  
)

export default component.exports